<template>
  <section class="w-100 px-4 d-flex flex-column justify-content-center align-items-center text-center">
    <h1 class="font-weight-normal">ご利用ありがとうございました。</h1>
  </section>
</template>

<script>
  export default {
    name: 'Thanks'
  }
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";

section {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-image: url("/background_sp.png");

  @include mq(md) {
    background-image: url("/background_pc.png");
  }

  h1 {
    font-size: 24px;

    @include mq(md) {
      font-size: 32px;
    }
  }
}
</style>
